export const showSubmissionFormAfterChecklist = () => {
    const $checklistButton = $('.js-checklist-button')
    const $checklist = $('.js-submission-checklist')
    const $submissonForm = $('.js-submission-form')
    const $videoImage = $('.js-submission-form-video-image')
    const $videoImageError = $('.js-video-image-error')
    const validImageTypes = ['image/png', 'image/jpeg']
    const maxFileSize = 2 * 1024 * 1024 // 2 MB in Bytes

    $checklistButton.on('click', () => {
        $checklist.fadeOut(400, () => {
            $submissonForm.fadeIn(200)
        })

        $('body,html').animate({ scrollTop: 0 }, 600)
    })

    $videoImage.on('change', function validateVideoImage () {
        const file = this.files[0]
        $videoImageError.text('')

        if (!file) return

        if ($.inArray(file.type, validImageTypes) < 0) {
            $videoImageError.text('Ungültiges Dateiformat. Bitte PNG oder JPG verwenden.')
            this.value = null
            return
        }

        if (file.size > maxFileSize) {
            $videoImageError.text('Das Bild ist zu groß. Maximal 2 MB sind erlaubt.')
            this.value = null
        }
    })
}
